import React, { useState, useEffect } from 'react';
import CampoComboParametro from '../../UI/campos/CampoComboParametro.js';
import CampoEditableFecha from '../../UI/campos/CampoEditableFecha.js';
import CampoEditableTexto from '../../UI/campos/CampoEditableTexto.js';
import CampoEditableMultilinea from '../../UI/campos/CampoEditableMultilinea.js';
import ComboSelector, { TipoClave } from '../../UI/campos/ComboSelector.js';
import * as TipoParametro from '../../constantes/TipoParametro.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import * as FuncionesTipoObjeto from '../../funciones/FuncionesTipoObjeto.js';
import * as TipoObjeto from '../../constantes/TipoObjeto.js';
import styles from '../EditarItemLista.module.css';

const CODIGOS_OBJETOS_PERMITIDOS = [
  TipoObjeto.CLUB,
  TipoObjeto.PAIS,
  TipoObjeto.ORGANIZADOR_TORNEOS,
];

const CamposBoletinesPersona = (props) => {
  const item = props.item || {};
  const editar = props.editar;
  const onCampoChange = props.onCampoChange;

  const { fetchData, isCargando, resetErroresGetLista } = useGetListaURL();
  const [listaOrigen, setListaOrigen] = useState([]);
  const [listaDestino, setListaDestino] = useState([]);
  const [listaBoletines, setListaBoletines] = useState([]);

  const codigoTipoOrigen = item && item.tipoObjetoOrigen ? item.tipoObjetoOrigen.codigo : null;
  const codigoTipoDestino = item && item.tipoObjetoDestino ? item.tipoObjetoDestino.codigo : null;
  const idBoletin = item && item.boletin ? item.boletin.id : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (codigoTipoOrigen) {
      const path = FuncionesTipoObjeto.UrlBoletin(codigoTipoOrigen, idBoletin);
      if (path) {
        fetchData(path, setListaOrigen);
      } else {
        setListaOrigen([]);
      }
    } else {
      setListaOrigen([]);
    }
  }, [fetchData, codigoTipoOrigen, idBoletin]);

  useEffect(() => {
    // Load boletines when editing the item
    if (editar) {
      fetchData('boletines_afa?tipoBoletin=J', setListaBoletines);
    }
  }, [fetchData, editar]);

  useEffect(() => {
    if (codigoTipoDestino) {
      const path = FuncionesTipoObjeto.UrlBoletin(codigoTipoDestino, idBoletin);
      if (path) {
        fetchData(path, setListaDestino);
      } else {
        setListaDestino([]);
      }
    } else {
      setListaDestino([]);
    }
  }, [fetchData, codigoTipoDestino, idBoletin]);

  const onOrigenElegido = (origen) => {
    onCampoChange('idOrigen', origen);
  };

  const onBoletinElegido = (boletin) => {
    onCampoChange('boletin', boletin);
  };

  const onDestinoElegido = (destino) => {
    onCampoChange('idDestino', destino);
  };

  // compute display objects so ComboSelector shows description instead of id
  const displayOrigen = item.origen
    ? item.origen
    : item.idOrigen
    ? listaOrigen.find((x) => x.id === (item.idOrigen.id ? item.idOrigen.id : item.idOrigen))
    : null;

  const displayDestino = item.destino
    ? item.destino
    : item.idDestino
    ? listaDestino.find((x) => x.id === (item.idDestino.id ? item.idDestino.id : item.idDestino))
    : null;

  return (
    <React.Fragment>
      {item && (
        <React.Fragment>
          <tr>
            <td className={`${styles.titulo}`}>Boletín</td>
            <td className={`${styles.valor} ${styles.valorCampoAncho}`} colSpan="3">
              {editar ? (
                <ComboSelector
                  lista={listaBoletines}
                  valorActual={item.boletin ? item.boletin.codigoBoletinJugadores : ''}
                  campoClave={TipoClave.ID}
                  campoDescripcion="codigoBoletinJugadores"
                  isCargando={isCargando}
                  estilo={styles.comboFijo}
                  onItemElegido={onBoletinElegido}
                />
              ) : item.boletin ? (
                item.boletin.codigoBoletinJugadores
              ) : (
                ''
              )}
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Tipo Pase</td>
            <td className={`${styles.valor}`} colSpan="2">
              <CampoComboParametro
                nombre="tipoPaseBoletin"
                tipoParametro={TipoParametro.TIPO_PASE_BOLETIN}
                estilo={`${styles.comboDatos}`}
                valor={item.tipoPaseBoletin}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Fecha Hasta</td>
            <td className={`${styles.valor} ${styles.valorCampoAncho}`} colSpan="3">
              <CampoEditableFecha
                nombre="fechaHasta"
                valor={item.fechaHasta}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Tipo Origen</td>
            <td className={`${styles.valor}`}>
              <CampoComboParametro
                nombre="tipoObjetoOrigen"
                tipoParametro={TipoParametro.TIPO_OBJETO}
                estilo={`${styles.comboDatos}`}
                valor={item.tipoObjetoOrigen}
                editar={editar}
                onChange={onCampoChange}
                allowedCodigos={CODIGOS_OBJETOS_PERMITIDOS}
              />
            </td>
            <td className={`${styles.titulo}`}>Origen</td>
            <td className={`${styles.valor}`}>
              {editar ? (
                <ComboSelector
                  lista={listaOrigen}
                  valorActual={
                    displayOrigen
                      ? displayOrigen.nombre
                        ? displayOrigen.nombre
                        : displayOrigen
                      : ''
                  }
                  campoClave={TipoClave.ID}
                  campoDescripcion="nombre"
                  isCargando={isCargando}
                  estilo={styles.comboFijo}
                  onItemElegido={onOrigenElegido}
                />
              ) : (
                item.origen && item.origen.nombre
              )}
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Tipo Destino</td>
            <td className={`${styles.valor}`}>
              <CampoComboParametro
                nombre="tipoObjetoDestino"
                tipoParametro={TipoParametro.TIPO_OBJETO}
                estilo={`${styles.comboDatos}`}
                valor={item.tipoObjetoDestino}
                editar={editar}
                onChange={onCampoChange}
                allowedCodigos={CODIGOS_OBJETOS_PERMITIDOS}
              />
            </td>
            <td className={`${styles.titulo}`}>Destino</td>
            <td className={`${styles.valor}`}>
              {editar ? (
                <ComboSelector
                  lista={listaDestino}
                  valorActual={
                    displayDestino
                      ? displayDestino.nombre
                        ? displayDestino.nombre
                        : displayDestino
                      : ''
                  }
                  campoClave={TipoClave.ID}
                  campoDescripcion="nombre"
                  isCargando={isCargando}
                  estilo={styles.comboFijo}
                  onItemElegido={onDestinoElegido}
                />
              ) : (
                item.destino && item.destino.nombre
              )}
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Observación</td>
            <td className={`${styles.valor}`} colSpan="3">
              <CampoEditableTexto
                nombre="observacion"
                valor={item.observacion}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Dudas</td>
            <td className={`${styles.valor}`} colSpan="3">
              <CampoEditableMultilinea
                filas="4"
                columnas="46"
                nombre="dudas"
                valor={item.dudas}
                editar={editar}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CamposBoletinesPersona;
